import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OverlayService {
  // Sidebar state
  private sidebarOpenSubject = new BehaviorSubject<boolean>(false);
  sidebarOpen$: Observable<boolean> = this.sidebarOpenSubject.asObservable();

  // Card modal / sheet modal state
  private cardModalOpenSubject = new BehaviorSubject<boolean>(false);
  cardModalOpen$: Observable<boolean> = this.cardModalOpenSubject.asObservable();

  /** ---------------- Sidebar Methods ---------------- */
  openSidebar() {
    this.sidebarOpenSubject.next(true);
  }

  closeSidebar() {
    this.sidebarOpenSubject.next(false);
  }

  toggleSidebar() {
    this.sidebarOpenSubject.next(!this.sidebarOpenSubject.value);
  }

  openCardModal() {
    console.log('[OverlayService] card modal open');
    this.cardModalOpenSubject.next(true);
  }

  closeCardModal() {
    console.log('[OverlayService] card modal close');
    this.cardModalOpenSubject.next(false);
  }

  toggleCardModal() {
    this.cardModalOpenSubject.next(!this.cardModalOpenSubject.value);
  }
}
